import * as React from "react";
import { css } from "aphrodite";
import { DayStyle } from "./DayStyle";

export const DayEmpty: React.FC = (): React.ReactElement => {
  return <span className={css(DayStyle.base)} />;
};
